import { useTranslate } from 'react-admin';

import caLocale from "@fullcalendar/core/locales/ca";
import esLocale from "@fullcalendar/core/locales/es";
import { ca, es } from 'date-fns/locale';

import polyglotI18nProvider from 'ra-i18n-polyglot';

import { caMessages } from './language_ca';
import { esMessages } from './language_es';



import { isPublicPage } from './utils';

let associationLang = -1;

export const setAssociationLang = lang => {  
    
    associationLang = lang >= 0 && languageMap.hasOwnProperty(lang) ? lang : defaultLanguage;
    i18nProvider.changeLocale(languageMap[associationLang]);        
    
};

export const messages = {
  ca: caMessages,
  es: esMessages,
};

export const locales = {
  ca: caLocale,
  es: esLocale,
};

export const languageMap = {
  0: 'ca',
  1: 'es'
};

export const localesMap = {
  0: ca,
  1: es
};

export const defaultLanguage = 0;

export const choicesLanguage = (translate, moreLanguagesEnabled) => {
  const choices = [{ id: 0, name: translate('common.language_0') }];
  if (moreLanguagesEnabled) {
    choices.push({ id: 1, name: translate('common.language_1') });
  }
  return choices;
};


const getLangFromHash = () => {
  const hash = window.location.hash || "";

  const [, queryString] = hash.split("?");

  if (!queryString) return null;

  const params = new URLSearchParams(queryString);
  return params.get("lg");
};

export const getLocaleLang = (langId) => {
    if (localesMap.hasOwnProperty(langId))
    {
        return localesMap[langId];
    }
    else
        return ca;
};

export const getLanguageFromStorage = () => {
    
  //const isLoggedIn = !!localStorage.getItem('auth');
  
  // 1️⃣ Llegim el valor guardat (pot ser null)
  const stored = localStorage.getItem('language');
  const storedId = stored !== null ? parseInt(stored, 10) : null;

  // 2️⃣ Intentem llegir ?lg=xx del search
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lg");

  // 3️⃣ Intentem llegir lg del hash
  const hashLang = getLangFromHash();

  // 4️⃣ Prioritat: URL → HASH → LOCALSTORAGE → DEFAULT
  const candidate = (urlLang || hashLang)?.toLowerCase();
  
  if(isPublicPage()) console.log('PAGINA PUBLICA'); else console.log('PAGINA PRIVADA'); 
  
  // 5️⃣ Si hi ha un idioma vàlid a la URL/hash, l'usem
  if (isPublicPage() && candidate && Object.values(languageMap).includes(candidate)) {
      console.log('Language ve per URL: ' + candidate);
      return candidate;
  }

  if (isPublicPage() && associationLang >= 0 && languageMap.hasOwnProperty(associationLang) ) {
      console.log('Language ve per variable associationLang global: ' + languageMap[associationLang]);
      return languageMap[associationLang];
  }
  // 6️⃣ Si hi ha un valor vàlid al localStorage, l'usem    
  if (!isPublicPage() && storedId !== null && languageMap.hasOwnProperty(storedId)) {
      console.log('Language ve per LocalStorage: ' + languageMap[storedId]);
        return languageMap[storedId];
  }
  // 7️⃣ Valor per defecte
  console.log('Language per defecte: ' + languageMap[defaultLanguage] );
  return languageMap[defaultLanguage];
};

export const getLanguageIdFromStorage = () => {
  // 1️⃣ Llegim el valor guardat (pot ser null)
  const stored = localStorage.getItem('language');
  const storedId = stored !== null ? parseInt(stored, 10) : null;

  // 2️⃣ Intentem llegir ?lg=xx del search
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lg");

  // 3️⃣ Intentem llegir lg del hash
  const hashLang = getLangFromHash();

  // 4️⃣ Prioritat: URL → HASH → LOCALSTORAGE → DEFAULT
  const candidate = (urlLang || hashLang)?.toLowerCase();

  // 5️⃣ Si hi ha un idioma vàlid a la URL/hash, retornem-ne el seu id
  if (candidate && Object.values(languageMap).includes(candidate)) {
    const langId = parseInt(
      Object.keys(languageMap).find(key => languageMap[key] === candidate),
      10
    );
    return isNaN(langId) ? defaultLanguage : langId;
  }

  // 6️⃣ Si hi ha un valor vàlid al localStorage, retornem-lo
  if (storedId !== null && languageMap.hasOwnProperty(storedId)) {
    return storedId;
  }

  // 7️⃣ Valor per defecte
  return defaultLanguage;
};


export const isLanguageReady = () => {
  const stored = localStorage.getItem('language');
  return stored !== null; // idioma establert per un login
};

// ✅ el provider sempre consulta l’idioma actual
const i18nProvider = polyglotI18nProvider(() => messages[getLanguageFromStorage()]);

export { useTranslate, i18nProvider };